<template>
  <div class="enroll_info">
    <div class="g-box">
      <div class="top-bg">
        <img width="1200px" src="../assets/img/jc.png" alt="" />
      </div>
      <div class="jc-form">
        <div class="tt">录取结果</div>
        <div class="form-input">
          <div class="label">录取年度</div>
          <div class="value">{{ enrollInfo.year }}</div>
        </div>
        <div class="form-input">
          <div class="label">姓名</div>
          <div class="value">{{ enrollInfo.name }}</div>
        </div>
        <div class="form-input">
          <div class="label">录取专业</div>
          <div class="value">{{ enrollInfo.major }}</div>
        </div>
        <div class="form-input">
          <div class="label">性别</div>
          <div class="value">{{ enrollInfo.gender }}</div>
        </div>
        <div @click="back" class="form-btn">返 回</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: this.$route.query,
      enrollInfo: {}
    };
  },

  mounted() {
    document.title = "录取查询";
    const link = document.querySelector('link[rel~="icon"]');
    if (link) {
      link.href = "";
    }
    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.href = "data:,";
    document.head.appendChild(newLink);
    this.removeFavicon();
    this.$api.ems.education.schoolRollContinue_searchEnrollInfo
      .get({
        idCardNo: this.query.idCardNo,
        siteId: "1783772064219987969"
      })
      .then(res => {
        this.enrollInfo = res.data;
      });
  },
  methods: {
    removeFavicon() {
      // 获取head标签中所有的link元素
      var links = document.getElementsByTagName("link");
      // 遍历所有的link元素
      for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute("rel") === "icon") {
          console.log(links[i], "linkid");
          // 移除该link元素
          links[i].parentNode.removeChild(links[i]);
        }
      }
    },
    back() {
      this.$router.push({
        path: "/enroll_info"
      });
    }
  }
};
</script>
<style lang="less" scoped>
.enroll_info {
  .jc-form {
    padding-top: 30px;
    .tt {
      font-family: Source Han Sans CN;
      font-size: 24px;
      font-weight: bold;
      color: #3d3d3d;
      text-align: center;
    }
    .form-input {
      margin: 30px auto 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eee;
      height: 46px;
      width: 400px;
      .label {
        width: 130px;
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }
      .value {
        font-size: 18px;
        font-weight: 600;
        color: #666;
      }
    }
    .form-btn {
      margin: 40px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      width: 400px;
      height: 48px;
      border-radius: 4px;
      background: #409eff;
    }
  }
}
</style>
